import type { ViewPermission } from '@repo/api-client'
import { AirplaneRegular, AlertRegular, ArrowClockwiseRegular, ArrowSwapRegular, ArrowTrendingRegular, ArrowUploadRegular, BeakerRegular, BoardRegular, BookmarkRegular, BriefcaseRegular, BuildingFactoryRegular, BuildingMultipleRegular, BuildingRegular, CalendarRegular, CallConnectingRegular, CallForwardRegular, CallInboundRegular, CallOutboundRegular, CallRegular, CellularData1Regular, CertificateRegular, ChatRegular, ChatWarningRegular, CheckmarkStarburstRegular, ClipboardCheckmarkRegular, ClipboardTaskListLtrRegular, ClockRegular, CloudArrowUpRegular, CoinMultipleRegular, ColorRegular, CommentTextRegular, CompassNorthwestRegular, ContactCardRegular, DataAreaRegular, DatabaseRegular, DataHistogramRegular, DataLineRegular, DataPieRegular, DocumentDataRegular, DocumentLockRegular, DocumentMultipleRegular, DocumentTableRegular, DocumentTextClockRegular, DocumentTextRegular, EyeRegular, FingerprintRegular, FolderOpenRegular, GlobeRegular, GridRegular, HandshakeRegular, HardDriveRegular, HistoryRegular, HomeRegular, HourglassRegular, ImageRegular, KeyRegular, LayerRegular, LightbulbRegular, LockClosedRegular, MegaphoneRegular, MicRegular, MoneyRegular, MusicNote2Regular, NewsRegular, OptionsRegular, PanelLeftRegular, PaymentRegular, PeopleRegular, PersonAddRegular, PersonAvailableRegular, PersonCircleRegular, PersonRegular, PersonSearchRegular, PersonSettingsRegular, PersonSquareRegular, PulseRegular, QuestionCircleRegular, ReceiptRegular, RibbonRegular, SavingsRegular, SendRegular, ServerRegular, SettingsRegular, ShareIosRegular, ShieldCheckmarkRegular, ShieldErrorRegular, ShieldQuestionRegular, ShieldRegular, SparkleRegular, TagMultipleRegular, TagRegular, TargetRegular, TaskListLtrRegular, TextNumberListLtrRegular, TextPercentRegular, TopSpeedRegular, VideoRegular, WalletRegular, WindowConsoleRegular, WrenchRegular, type FluentIcon } from '@fluentui/react-icons'
export interface NavigationItem {
  id: string
  name: string
  nameRu: string
  title?: string // Alias for name
  type?: string // Type of navigation item (menu, link, divider, etc.)
  link?: string
  icon?: FluentIcon | string
  children?: NavigationItem[]
  order: number
  viewName?: string
  subtitle?: string // Optional description/subtitle
}

const iconRegistry: Record<string, FluentIcon> = {
  Activity: PulseRegular,
  ActivitySquare: PulseRegular,
  ArrowLeftRight: ArrowSwapRegular,
  Award: RibbonRegular,
  Badge: CertificateRegular,
  BadgeCheck: CheckmarkStarburstRegular,
  BadgePercent: TextPercentRegular,
  Banknote: MoneyRegular,
  BarChart: DataHistogramRegular,
  BarChart4: DataHistogramRegular,
  Bell: AlertRegular,
  Bookmark: BookmarkRegular,
  Briefcase: BriefcaseRegular,
  Building: BuildingRegular,
  Building2: BuildingMultipleRegular,
  Calendar: CalendarRegular,
  ChartArea: DataAreaRegular,
  ClipboardCheck: ClipboardCheckmarkRegular,
  ClipboardList: ClipboardTaskListLtrRegular,
  Clock: ClockRegular,
  CloudUpload: CloudArrowUpRegular,
  Coins: CoinMultipleRegular,
  Compass: CompassNorthwestRegular,
  Contact: ContactCardRegular,
  CreditCard: PaymentRegular,
  Database: DatabaseRegular,
  DollarSign: MoneyRegular,
  Eye: EyeRegular,
  Factory: BuildingFactoryRegular,
  FileAudio: MusicNote2Regular,
  FileBarChart: DocumentDataRegular,
  FileClock: DocumentTextClockRegular,
  FileLock: DocumentLockRegular,
  FileSpreadsheet: DocumentTableRegular,
  FileStack: DocumentMultipleRegular,
  FileText: DocumentTextRegular,
  Fingerprint: FingerprintRegular,
  FlaskConical: BeakerRegular,
  FolderOpen: FolderOpenRegular,
  Gauge: TopSpeedRegular,
  Globe: GlobeRegular,
  Grid: GridRegular,
  Handshake: HandshakeRegular,
  HardDrive: HardDriveRegular,
  HelpCircle: QuestionCircleRegular,
  History: HistoryRegular,
  Home: HomeRegular,
  Hourglass: HourglassRegular,
  IdCard: ContactCardRegular,
  Image: ImageRegular,
  Key: KeyRegular,
  KeyRound: KeyRegular,
  KeySquare: KeyRegular,
  Layers: LayerRegular,
  LayoutDashboard: BoardRegular,
  LayoutPanelLeft: PanelLeftRegular,
  Lightbulb: LightbulbRegular,
  LineChart: DataLineRegular,
  ListOrdered: TextNumberListLtrRegular,
  ListTodo: TaskListLtrRegular,
  Lock: LockClosedRegular,
  Megaphone: MegaphoneRegular,
  MessageCircle: ChatRegular,
  MessageCircleWarning: ChatWarningRegular,
  MessageSquare: ChatRegular,
  MessageSquareText: CommentTextRegular,
  MessageSquareWarning: ChatWarningRegular,
  Mic: MicRegular,
  Newspaper: NewsRegular,
  Palette: ColorRegular,
  Percent: TextPercentRegular,
  Phone: CallRegular,
  PhoneCall: CallConnectingRegular,
  PhoneForwarded: CallForwardRegular,
  PhoneIncoming: CallInboundRegular,
  PhoneOutgoing: CallOutboundRegular,
  PieChart: DataPieRegular,
  PiggyBank: SavingsRegular,
  Plane: AirplaneRegular,
  Receipt: ReceiptRegular,
  ReceiptText: ReceiptRegular,
  RefreshCw: ArrowClockwiseRegular,
  ScrollText: DocumentTextRegular,
  Send: SendRegular,
  Server: ServerRegular,
  Settings: SettingsRegular,
  Settings2: OptionsRegular,
  Share2: ShareIosRegular,
  Shield: ShieldRegular,
  ShieldAlert: ShieldErrorRegular,
  ShieldCheck: ShieldCheckmarkRegular,
  ShieldQuestion: ShieldQuestionRegular,
  Signal: CellularData1Regular,
  Sliders: OptionsRegular,
  SlidersHorizontal: OptionsRegular,
  SlidersVertical: OptionsRegular,
  Sparkles: SparkleRegular,
  Tag: TagRegular,
  Tags: TagMultipleRegular,
  Target: TargetRegular,
  Terminal: WindowConsoleRegular,
  TrendingUp: ArrowTrendingRegular,
  Upload: ArrowUploadRegular,
  User: PersonRegular,
  UserCheck: PersonAvailableRegular,
  UserCircle: PersonCircleRegular,
  UserCog: PersonSettingsRegular,
  UserPlus: PersonAddRegular,
  UserRound: PersonRegular,
  UserRoundPlus: PersonAddRegular,
  UserSearch: PersonSearchRegular,
  UserSquare: PersonSquareRegular,
  Users: PeopleRegular,
  Users2: PeopleRegular,
  UsersRound: PeopleRegular,
  Video: VideoRegular,
  Wallet: WalletRegular,
  Wrench: WrenchRegular,
}

export const iconMap: Record<string, FluentIcon> = {
  ...iconRegistry,
  ...Object.fromEntries(
    Object.entries(iconRegistry).map(([name, icon]) => [name.toLowerCase(), icon])
  ),
  // Legacy aliases for backward compatibility
  home: HomeRegular,
  users: PeopleRegular,
  message: ChatRegular,
  phone: CallRegular,
  settings: SettingsRegular,
  briefcase: BriefcaseRegular,
  wallet: WalletRegular,
  filetext: DocumentTextRegular,
  barchart: DataHistogramRegular,
  shield: ShieldRegular,
  appstore: GridRegular,
  contacts: PeopleRegular,
  user: PersonRegular,
  lock: LockClosedRegular,
  key: KeyRegular,
  calendar: CalendarRegular,
  trending: ArrowTrendingRegular,
  building: BuildingRegular,
  dollar: MoneyRegular,
  credit: PaymentRegular,
  filestack: DocumentMultipleRegular,
  upload: ArrowUploadRegular,
  database: DatabaseRegular,
  activity: PulseRegular,
  piechart: DataPieRegular,
  layers: LayerRegular,
  tag: TagRegular,
  bell: AlertRegular,
  help: QuestionCircleRegular,
  globe: GlobeRegular,
  palette: ColorRegular,
  clock: ClockRegular,
  award: RibbonRegular,
  lightbulb: LightbulbRegular,
  newspaper: NewsRegular,
  clipboardlist: ClipboardTaskListLtrRegular,
  target: TargetRegular,
}

// Navigation item definitions (based on view names) - used by navigationMachine
export const navigationDefinitions: Record<string, Partial<NavigationItem>> = {
  WEB_ROOT: {
    name: 'Dashboard',
    nameRu: 'Главная',
    link: '/dashboard',
    icon: 'home',
    type: 'basic',
  },

  TOP_HEADER_GROUP: {
    name: 'Navigation',
    nameRu: 'Навигация',
    icon: 'compass',
    type: 'group',
  },


  // Main application groups
  APPLICATIONS_GROUP: {
    name: 'Applications',
    nameRu: 'Приложения',
    icon: 'appstore',
    type: 'group',
  },

  CALLS_GROUP: {
    name: 'Calls',
    nameRu: 'Звонки',
    icon: 'phonecall',
    type: 'group',
  },

  ADMIN_GROUP: {
    name: 'Admin',
    nameRu: 'Администрирование',
    icon: 'shieldcheck',
    type: 'group',
  },

  CRM_GROUP: {
    name: 'CRM',
    nameRu: 'Управление взаимоотношениями с клиентами',
    icon: 'handshake',
    link: '/admin/crm/interactions',
    type: 'group',
  },

  CRM_INTERACTIONS: {
    name: 'Interactions',
    nameRu: 'Взаимодействия',
    link: '/admin/crm/interactions',
    icon: 'messagesquaretext',
    type: 'basic',
  },

  CRM_DASHBOARD: {
    name: 'Dashboard',
    nameRu: 'Панель',
    link: '/admin/crm/dashboard',
    icon: 'layoutdashboard',
    type: 'basic',
  },

  CRM_CUSTOMERS: {
    name: 'Customers',
    nameRu: 'Клиенты',
    link: '/admin/crm/customers',
    icon: 'building2',
    type: 'basic',
  },

  LIMS_GROUP: {
    name: 'LIMS',
    nameRu: 'Лабораторная информационная система',
    icon: 'flaskconical',
    type: 'group',
  },

  LIMS_PHONE_NUMBERS: {
    name: 'Phone Numbers',
    nameRu: 'Телефонные номера',
    link: '/admin/lims/phone-numbers',
    icon: 'phoneforwarded',
    type: 'basic',
  },

  LIMS_ACCOUNTS: {
    name: 'Accounts',
    nameRu: 'Аккаунты',
    link: '/admin/lims/accounts',
    icon: 'idcard',
    type: 'basic',
  },

  ANALYTICS_GROUP: {
    name: 'Analytics',
    nameRu: 'Аналитика',
    icon: 'linechart',
    type: 'group',
  },

  DOCUMENTS_MENU: {
    name: 'Documents',
    nameRu: 'Документы',
    icon: 'folderopen',
    type: 'group',
  },

  BACKEND_MENU: {
    name: 'Backend',
    nameRu: 'Управление бэкендом',
    icon: 'server',
    link: '/admin/backend/file-managment',
    type: 'group',
  },

  BACKEND_UPLOAD_PUBLIC_FILE: {
    name: 'Upload File',
    nameRu: 'Загрузить файл',
    link: '/admin/backend/upload-file',
    icon: 'cloudupload',
    type: 'basic',
  },

  WALLET_MENU: {
    name: 'Wallet',
    nameRu: 'Управление кошельком',
    icon: 'piggybank',
    link: '/admin/wallet/dashboard',
    type: 'group',
  },

  BILLING_MENU: {
    name: 'Billing',
    nameRu: 'Управление биллингом',
    icon: 'receipt',
    link: '/admin/billing/dashboard',
    type: 'group',
  },

  USERS_GROUP: {
    name: 'Users',
    nameRu: 'Пользователи',
    icon: 'usersround',
    type: 'group',
  },

  ACCESS_MENU: {
    name: 'Access',
    nameRu: 'Доступ',
    icon: 'keyround',
    link: '/admin/access/roles',
    type: 'group',
  },

  AUTH_MENU: {
    name: 'Auth',
    nameRu: 'Авторизация',
    icon: 'fingerprint',
    link: '/admin/auth/codes',
    type: 'group',
  },


  // Individual menu items
  CHAT: {
    name: 'Chat',
    nameRu: 'Чат',
    link: '/chat',
    icon: 'messagecircle',
    type: 'basic',
  },

  CHAT_MAIN: {
    name: 'Chat',
    nameRu: 'Чат',
    link: '/chat',
    icon: 'messagesquare',
    type: 'basic',
  },

  CONTACT_MAIN: {
    name: 'Contacts',
    nameRu: 'Контакты',
    link: '/contacts',
    icon: 'contact',
    type: 'basic',
  },

  CONTACTS: {
    name: 'Contacts',
    nameRu: 'Контакты',
    link: '/contacts',
    icon: 'users',
    type: 'basic',
  },

  CALL_MAIN: {
    name: 'Calls',
    nameRu: 'Звонки',
    link: '/calls',
    icon: 'phone',
    type: 'basic',
    subtitle: 'View and manage call history',
  },

  CALLS: {
    name: 'Calls',
    nameRu: 'Звонки',
    link: '/calls',
    icon: 'phoneincoming',
    type: 'basic',
    subtitle: 'View and manage call history',
  },

  CALLS_DASHBOARD: {
    name: 'Call Dashboard',
    nameRu: 'Панель звонков',
    link: '/admin/cdr',
    icon: 'layoutdashboard',
    type: 'basic',
    subtitle: 'Call analytics and metrics',
  },

  CALLS_HISTORY: {
    name: 'Call History',
    nameRu: 'История звонков',
    link: '/admin/cdr/history',
    icon: 'history',
    type: 'basic',
  },

  CALLS_RECORDS: {
    name: 'Call Records',
    nameRu: 'Записи звонков',
    link: '/admin/cdr/records',
    icon: 'fileaudio',
    type: 'basic',
  },

  CALL_SETTINGS: {
    name: 'Call Settings',
    nameRu: 'Настройки звонков',
    icon: 'slidersvertical',
    type: 'group',
  },

  WALLET_DASHBOARD: {
    name: 'Wallet',
    nameRu: 'Кошелёк',
    link: '/wallet',
    icon: 'wallet',
    type: 'basic',
  },

  WALLET_TRANSACTIONS: {
    name: 'Transactions',
    nameRu: 'Транзакции',
    link: '/wallet/transactions',
    icon: 'arrowleftright',
    type: 'basic',
  },

  WALLET_TRANSFERS: {
    name: 'Transfers',
    nameRu: 'Переводы',
    link: '/wallet/transfers',
    icon: 'send',
    type: 'basic',
  },

  WALLET_SOURCES: {
    name: 'Payment Methods',
    nameRu: 'Способы оплаты',
    link: '/wallet/payment-methods',
    icon: 'creditcard',
    type: 'basic',
  },

  BILLING_USAGE: {
    name: 'Usage',
    nameRu: 'Использование',
    link: '/admin/billing',
    icon: 'activitysquare',
    type: 'basic',
  },

  CONFERENCE: {
    name: 'Conference',
    nameRu: 'Конференция',
    link: '/conference',
    icon: 'video',
    type: 'basic',
  },

  SETTINGS_MAIN: {
    name: 'Settings',
    nameRu: 'Настройки',
    link: '/settings',
    icon: 'settings2',
    type: 'basic',
  },

  SETTINGS_PROFILE: {
    name: 'Profile',
    nameRu: 'Профиль',
    link: '/settings/profile',
    icon: 'user',
    type: 'basic',
  },

  SETTINGS_NOTIFICATIONS: {
    name: 'Notifications',
    nameRu: 'Уведомления',
    link: '/settings/notifications',
    icon: 'bell',
    type: 'basic',
  },

  SETTINGS_VOICE_AND_VIDEO: {
    name: 'Voice & Video',
    nameRu: 'Голос и видео',
    link: '/settings/voice-video',
    icon: 'mic',
    type: 'basic',
  },

  SETTINGS_LANGUAGE: {
    name: 'Language',
    nameRu: 'Язык',
    link: '/settings/language',
    icon: 'globe',
    type: 'basic',
  },

  SETTINGS_DECOR: {
    name: 'Appearance',
    nameRu: 'Оформление',
    link: '/settings/appearance',
    icon: 'palette',
    type: 'basic',
  },

  SETTINGS_DATA_AND_STORAGE: {
    name: 'Data & Storage',
    nameRu: 'Данные и хранилище',
    link: '/settings/file-media',
    icon: 'database',
    type: 'basic',
  },

  SETTINGS_SUPPORT: {
    name: 'Help',
    nameRu: 'Помощь',
    link: '/settings/help',
    icon: 'helpcircle',
    type: 'basic',
  },

  SETTINGS_ADD_ACCOUNT: {
    name: 'Add Account',
    nameRu: 'Добавить аккаунт',
    link: '/settings',
    icon: 'userplus',
    type: 'basic',
  },

  SETTINGS_UPDATES: {
    name: 'Updates',
    nameRu: 'Обновления',
    link: '/settings',
    icon: 'refreshcw',
    type: 'basic',
  },

  SETTINGS_CONFIDENTIALITY: {
    name: 'Privacy',
    nameRu: 'Конфиденциальность',
    link: '/settings/privacy',
    icon: 'shieldalert',
    type: 'basic',
  },

  SETTINGS_PRIVACY_POLICY: {
    name: 'Privacy Policy',
    nameRu: 'Политика конфиденциальности',
    link: '/settings/privacy-policy',
    icon: 'filelock',
    type: 'basic',
  },

  USERS_SEARCH: {
    name: 'Users',
    nameRu: 'Пользователи',
    link: '/admin/users',
    icon: 'usersearch',
    type: 'basic',
  },

  USER_TAGS: {
    name: 'Tags',
    nameRu: 'Теги',
    link: '/admin/users/tags',
    icon: 'tag',
    type: 'basic',
  },

  CUSTOM_USER_MESSAGE_REPORTS: {
    name: 'Message Reports',
    nameRu: 'Отчеты о сообщениях',
    link: '/admin/users/message-reports',
    icon: 'messagecirclewarning',
    type: 'basic',
  },

  CRM_WORKSPACE: {
    name: 'CRM Workspace',
    nameRu: 'Рабочее пространство',
    link: '/admin/crm',
    icon: 'layoutpanelleft',
    type: 'basic',
  },

  CRM_SETTINGS: {
    name: 'CRM Settings',
    nameRu: 'Настройки CRM',
    link: '/admin/crm/settings',
    icon: 'sliders',
    type: 'basic',
  },

  CRM_BUSINESS: {
    name: 'Business',
    nameRu: 'Бизнес',
    link: '/admin/crm/settings/crm-business',
    icon: 'factory',
    type: 'basic',
  },

  CRM_CHANNELS: {
    name: 'Channels',
    nameRu: 'Каналы',
    link: '/admin/crm/settings/crm-channels',
    icon: 'share2',
    type: 'basic',
  },

  CRM_MEMBERS: {
    name: 'Members',
    nameRu: 'Участники',
    link: '/admin/crm/members',
    icon: 'userround',
    type: 'basic',
  },

  CRM_QUEUES: {
    name: 'Queues',
    nameRu: 'Очереди',
    link: '/admin/crm/settings/crm-queue',
    icon: 'listordered',
    type: 'basic',
  },


  // Analytics
  ANALYTICS_DASHBOARD: {
    name: 'Analytics',
    nameRu: 'Аналитика',
    link: '/admin/dashboard/real-time',
    icon: 'piechart',
    type: 'basic',
  },

  ANALYTICS_REAL: {
    name: 'Real-time',
    nameRu: 'В реальном времени',
    link: '/admin/dashboard/real-time',
    icon: 'signal',
    type: 'basic',
  },

  ANALYTICS_EVENTS: {
    name: 'Events',
    nameRu: 'События',
    link: '/admin/dashboard/events',
    icon: 'calendar',
    type: 'basic',
  },

  ANALYTICS_AUDIENCE: {
    name: 'Audience',
    nameRu: 'Аудитория',
    link: '/admin/dashboard/historical',
    icon: 'usersquare',
    type: 'basic',
  },

  CALLS_METRICS: {
    name: 'Metrics',
    nameRu: 'Метрики',
    link: '/admin/cdr/metrics',
    icon: 'chartarea',
    type: 'basic',
  },


  // Backend
  BACKEND_APIKEYS: {
    name: 'API Keys',
    nameRu: 'API ключи',
    link: '/admin/backend/api-keys',
    icon: 'key',
    type: 'basic',
  },

  BACKEND_LOGS: {
    name: 'Logs',
    nameRu: 'Логи',
    link: '/admin/backend/logs',
    icon: 'terminal',
    type: 'basic',
  },

  BACKEND_STORAGE: {
    name: 'Storage',
    nameRu: 'Хранилище',
    link: '/admin/backend/file-managment',
    icon: 'harddrive',
    type: 'basic',
  },


  // Access
  ACCESS_ROLES: {
    name: 'Roles',
    nameRu: 'Роли',
    link: '/admin/access/roles',
    icon: 'shieldquestion',
    type: 'basic',
  },

  ACCESS_PERMISSIONS: {
    name: 'Permissions',
    nameRu: 'Разрешения',
    link: '/admin/access/rules',
    icon: 'keysquare',
    type: 'basic',
  },

  ACCESS_VIEWS: {
    name: 'Views',
    nameRu: 'Представления',
    link: '/admin/access/views',
    icon: 'eye',
    type: 'basic',
  },

  ACCESS_POLICIES: {
    name: 'Policies',
    nameRu: 'Политики',
    link: '/admin/access/ip-policies',
    icon: 'scrolltext',
    type: 'basic',
  },

  ACCESS_TAGS: {
    name: 'Tags',
    nameRu: 'Теги',
    link: '/admin/access/tags',
    icon: 'bookmark',
    type: 'basic',
  },

  ACCESS_LOGS: {
    name: 'Logs',
    nameRu: 'Логи',
    link: '/admin/access/logs',
    icon: 'fileclock',
    type: 'basic',
  },


  // HR Module
  HR_GROUP: {
    name: 'HR',
    nameRu: 'Персонал',
    icon: 'badge',
    type: 'group',
  },

  HR_ADMIN_GROUP: {
    name: 'HR Admin',
    nameRu: 'HR (Админ)',
    icon: 'usercog',
    type: 'group',
  },

  HR_MAIN: {
    name: 'HR Overview',
    nameRu: 'Обзор HR',
    link: '/hr',
    icon: 'userroundplus',
    type: 'basic',
  },

  HR_EMPLOYEES: {
    name: 'Employees',
    nameRu: 'Сотрудники',
    link: '/hr/employees',
    icon: 'usercog',
    type: 'basic',
  },

  HR_DEPARTMENTS: {
    name: 'Departments',
    nameRu: 'Отделы',
    link: '/hr/departments',
    icon: 'building',
    type: 'basic',
  },


  // Admin HR Pages
  HR_ADMIN_KPI: {
    name: 'KPI Management',
    nameRu: 'Управление KPI',
    link: '/admin/hr/kpi',
    icon: 'target',
    type: 'basic',
  },

  HR_ADMIN_ACHIEVEMENTS: {
    name: 'Achievements',
    nameRu: 'Достижения',
    link: '/admin/hr/achievements',
    icon: 'award',
    type: 'basic',
  },

  HR_ADMIN_SURVEYS: {
    name: 'Surveys',
    nameRu: 'Опросы',
    link: '/admin/hr/surveys',
    icon: 'clipboardlist',
    type: 'basic',
  },


  // Client HR Pages
  HR_MY_KPI: {
    name: 'My KPI',
    nameRu: 'Мои KPI',
    link: '/hr/my-kpi',
    icon: 'target',
    type: 'basic',
  },

  HR_MY_ACHIEVEMENTS: {
    name: 'My Achievements',
    nameRu: 'Мои достижения',
    link: '/hr/my-achievements',
    icon: 'award',
    type: 'basic',
  },

  HR_SURVEYS: {
    name: 'Surveys',
    nameRu: 'Опросы',
    link: '/hr/surveys',
    icon: 'clipboardlist',
    type: 'basic',
  },

  HR_NEWS: {
    name: 'News',
    nameRu: 'Новости',
    link: '/hr/news',
    icon: 'newspaper',
    type: 'basic',
  },

  ACCESS_RULES: {
    name: 'Access Rules',
    nameRu: 'Правила доступа',
    link: '/admin/access/rules',
    icon: 'shield',
    type: 'basic',
  },

  ALL_DOCUMENTS: {
    name: 'All Documents',
    nameRu: 'Все документы',
    link: '/admin/documents',
    icon: 'filetext',
    type: 'basic',
  },

  AUTH_HISTORY: {
    name: 'Auth Codes',
    nameRu: 'Коды авторизации',
    link: '/admin/auth/codes',
    icon: 'history',
    type: 'basic',
  },

  BACKEND_LOGS_ENDPOINTS: {
    name: 'Endpoint Logs',
    nameRu: 'Логи эндпоинтов',
    link: '/admin/backend/endpoint-logs',
    icon: 'terminal',
    type: 'basic',
  },

  BACKEND_LOGS_ERRORS: {
    name: 'Error Logs',
    nameRu: 'Логи ошибок',
    link: '/admin/backend/error-logs',
    icon: 'terminal',
    type: 'basic',
  },

  BACKEND_LOGS_NAVIGATION: {
    name: 'Navigation Logs',
    nameRu: 'Логи навигации',
    link: '/admin/backend/navigation-logs',
    icon: 'terminal',
    type: 'basic',
  },

  BACKEND_LOGS_USERS: {
    name: 'User Logs',
    nameRu: 'Логи пользователей',
    link: '/admin/backend/user-logs',
    icon: 'terminal',
    type: 'basic',
  },

  BILLING_DASHBOARD: {
    name: 'Billing Dashboard',
    nameRu: 'Панель биллинга',
    link: '/admin/billing',
    icon: 'layoutdashboard',
    type: 'basic',
  },

  CALL_QUALITY_SETTINGS: {
    name: 'Call Quality',
    nameRu: 'Качество связи',
    link: '/admin/cdr/quality',
    icon: 'gauge',
    type: 'basic',
  },

  CHAT_PROFILE_BUTTON: {
    name: 'Profile',
    nameRu: 'Профиль',
    type: 'basic',
  },

  CUSTOM_CALL_ROUTES: {
    name: 'Custom Routes',
    nameRu: 'Пользовательские маршруты',
    type: 'basic',
  },

  CUSTOM_CALL_ROUTE_TABLE: {
    name: 'Custom Route Table',
    nameRu: 'Таблица пользовательских маршрутов',
    link: '/admin/cdr/route-tables',
    icon: 'filespreadsheet',
    type: 'basic',
  },

  DOCUMENT_SETTINGS: {
    name: 'Document Settings',
    nameRu: 'Настройки документов',
    link: '/admin/documents',
    icon: 'settings',
    type: 'basic',
  },

  DOCUMENT_SETTINGS_ML_PROFILES: {
    name: 'ML Profiles',
    nameRu: 'ML-профили',
    link: '/admin/documents/ml-profiles',
    icon: 'sparkles',
    type: 'basic',
  },

  DOCUMENT_SETTINGS_SETTINGS_SETS: {
    name: 'Settings Sets',
    nameRu: 'Наборы настроек',
    link: '/admin/documents/sets',
    icon: 'layers',
    type: 'basic',
  },

  DOCUMENT_SETTINGS_SET_ANNOTATIONS: {
    name: 'Set Annotations',
    nameRu: 'Аннотации набора',
    link: '/admin/documents/set-annotations',
    icon: 'filetext',
    type: 'basic',
  },

  DOCUMENT_SETTINGS_TYPE_ANNOTATIONS: {
    name: 'Type Annotations',
    nameRu: 'Аннотации типа',
    link: '/admin/documents/type-annotations',
    icon: 'filetext',
    type: 'basic',
  },

  IMPERSONATION_ACCOUNT: {
    name: 'Impersonation',
    nameRu: 'Имперсонация',
    type: 'basic',
  },

  NEW_DOCUMENTS: {
    name: 'New Documents',
    nameRu: 'Новые документы',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_ACTIVITY_LOGS: {
    name: 'Activity Logs',
    nameRu: 'Журнал активности',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_APPLICATIONS: {
    name: 'Applications',
    nameRu: 'Приложения',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_BILLING: {
    name: 'Billing',
    nameRu: 'Биллинг',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_CAN_EDIT: {
    name: 'Can Edit',
    nameRu: 'Может редактировать',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_INFO: {
    name: 'Information',
    nameRu: 'Информация',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_INTERACTIONS: {
    name: 'Interactions',
    nameRu: 'Взаимодействия',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_SESSIONS: {
    name: 'Sessions',
    nameRu: 'Сессии',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_SIP_SETTINGS: {
    name: 'SIP Configuration',
    nameRu: 'Конфигурация SIP',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_STORAGE: {
    name: 'Storage',
    nameRu: 'Хранилище',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_SUBMENU: {
    name: 'Profile',
    nameRu: 'Профиль',
    type: 'group',
  },

  USER_MANAGEMENT_PROFILE_USER_CALL_HISTORY: {
    name: 'Call History',
    nameRu: 'История звонков',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_WALLET: {
    name: 'Wallet',
    nameRu: 'Кошелёк',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_WALLET_INTENTS: {
    name: 'Payment Intents',
    nameRu: 'Платёжные намерения',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_WALLET_SOURCES: {
    name: 'Payment Methods',
    nameRu: 'Способы оплаты',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_WALLET_TRANSACTIONS: {
    name: 'Transactions',
    nameRu: 'Транзакции',
    type: 'basic',
  },

  USER_MANAGEMENT_PROFILE_WALLET_TRANSFERS: {
    name: 'Transfers',
    nameRu: 'Переводы',
    type: 'basic',
  },

  VOICE_MAIL_SETTINGS: {
    name: 'Voicemail',
    nameRu: 'Голосовая почта',
    type: 'basic',
  },

  WALLET_DESCRIPTIONS: {
    name: 'Transaction Descriptions',
    nameRu: 'Описания транзакций',
    link: '/admin/wallet/descriptions',
    icon: 'receipttext',
    type: 'basic',
  },

  WALLET_INTENTS: {
    name: 'Payment Intents',
    nameRu: 'Платёжные намерения',
    link: '/admin/wallet/intents',
    icon: 'banknote',
    type: 'basic',
  },

  HR_KPI: {
    name: 'KPI',
    nameRu: 'Цели и KPI',
    link: '/admin/hr/kpi',
    icon: 'target',
    type: 'basic',
  },

  HR_ACHIEVEMENTS: {
    name: 'Achievements',
    nameRu: 'Достижения',
    link: '/admin/hr/achievements',
    icon: 'award',
    type: 'basic',
  },

  HR_EMPLOYEE_SURVEYS: {
    name: 'Surveys',
    nameRu: 'Опросы',
    link: '/hr/surveys',
    icon: 'clipboardlist',
    type: 'basic',
  },


  // ── Additional API views ──
  ACCESS_GROUPS: {
    name: 'Access Groups',
    nameRu: 'Группы',
    link: '/admin/access/groups',
    icon: 'users2',
    type: 'basic',
  },

  ADD_ACCOUNT: {
    name: 'Add Account',
    nameRu: 'Добавить аккаунт',
    type: 'basic',
  },

  APPS_MENU: {
    name: 'Apps Menu',
    nameRu: 'Приложения',
    type: 'group',
  },

  APPS_SEARCH: {
    name: 'Apps Search',
    nameRu: 'Поиск',
    type: 'basic',
  },

  APPS_VERIFY: {
    name: 'Apps Verify',
    nameRu: 'Верификация',
    type: 'basic',
  },

  AUTH_CODES: {
    name: 'Auth Codes',
    nameRu: 'Коды авторизации',
    link: '/admin/auth/codes',
    icon: 'keysquare',
    type: 'basic',
  },

  AUTH_SETTINGS: {
    name: 'Auth Settings',
    nameRu: 'Настройки авторизации',
    link: '/admin/auth/settings',
    icon: 'shield',
    type: 'basic',
  },

  BACKEND_EXPORTER: {
    name: 'Backend Exporter',
    nameRu: 'Экспорт',
    link: '/admin/exporter',
    icon: 'filespreadsheet',
    type: 'basic',
  },

  BACKEND_REPORTS: {
    name: 'Backend Reports',
    nameRu: 'Отчёты',
    link: '/admin/backend/reports',
    icon: 'filebarchart',
    type: 'basic',
  },

  BILLING_ASSETS: {
    name: 'Billing Assets',
    nameRu: 'Активы',
    link: '/admin/billing/assets',
    icon: 'coins',
    type: 'basic',
  },

  BILLING_DESCRIPTIONS: {
    name: 'Billing Descriptions',
    nameRu: 'Описания',
    link: '/admin/billing/descriptions',
    icon: 'receipttext',
    type: 'basic',
  },

  BILLING_PLANS: {
    name: 'Billing Plans',
    nameRu: 'Планы',
    link: '/admin/billing/plans',
    icon: 'clipboardlist',
    type: 'basic',
  },

  BILLING_ROUTES: {
    name: 'Billing Routes',
    nameRu: 'Маршруты',
    link: '/admin/billing/routes',
    icon: 'phoneforwarded',
    type: 'basic',
  },

  BILLING_SERVICES: {
    name: 'Billing Services',
    nameRu: 'Услуги',
    link: '/admin/billing/services',
    icon: 'briefcase',
    type: 'group',
  },

  CALL_FLOW_AUDIO: {
    name: 'Call Flow Audio',
    nameRu: 'Аудио потока',
    link: '/admin/crm/settings/flow-audio',
    icon: 'fileaudio',
    type: 'basic',
  },

  CALL_FLOW_IVR: {
    name: 'Call Flow IVR',
    nameRu: 'IVR',
    link: '/admin/crm/settings/flow-ivr',
    icon: 'phone',
    type: 'basic',
  },

  CRM_AUDIO: {
    name: 'CRM Audio',
    nameRu: 'Аудио',
    link: '/admin/crm/settings/flow-audio',
    icon: 'fileaudio',
    type: 'basic',
  },

  CRM_SLA: {
    name: 'CRM SLA',
    nameRu: 'SLA',
    link: '/admin/crm/settings/crm-sla',
    icon: 'hourglass',
    type: 'basic',
  },

  CRM_TAGS: {
    name: 'CRM Tags',
    nameRu: 'Теги',
    link: '/admin/crm/settings/crm-tag',
    icon: 'tags',
    type: 'basic',
  },

  CRM_TASKS: {
    name: 'CRM Tasks',
    nameRu: 'Задачи',
    type: 'group',
  },

  CUSTOM_CALL_MAPPING_RULE: {
    name: 'Custom Call Mapping Rule',
    nameRu: 'Правила маппинга',
    link: '/admin/cdr/mapping-rules',
    icon: 'settings',
    type: 'basic',
  },

  'DOCUMENT_SETTINGS__SET_GROUPS': {
    name: 'Document Settings Set Groups',
    link: '/admin/documents/set-groups',
    icon: 'folderopen',
    type: 'basic',
  },

  'DOCUMENT_SETTINGS__TYPES': {
    name: 'Document Settings Types',
    link: '/admin/documents/types',
    icon: 'filetext',
    type: 'basic',
  },

  ENTITIES_MENU: {
    name: 'Entities Menu',
    nameRu: 'Сущности',
    icon: 'building2',
    link: '/admin/entities',
    type: 'group',
  },

  ENTITY_DASHBOARD: {
    name: 'Entity Dashboard',
    nameRu: 'Панель',
    link: '/admin/entities',
    icon: 'layoutdashboard',
    type: 'basic',
  },

  ENTITY_SEARCH: {
    name: 'Entity Search',
    nameRu: 'Поиск',
    link: '/admin/entities',
    icon: 'building',
    type: 'basic',
  },

  ENTITY_SETTINGS: {
    name: 'Entity Settings',
    nameRu: 'Настройки',
    link: '/admin/entities',
    icon: 'settings',
    type: 'basic',
  },

  HR_ENGAGEMENT_GROUP: {
    name: 'HR Engagement Group',
    nameRu: 'Вовлеченность',
    type: 'group',
  },

  HR_ENGAGEMENT_IDEAS: {
    name: 'HR Engagement Ideas',
    nameRu: 'Идеи',
    link: '/engagement/ideas',
    icon: 'lightbulb',
    type: 'basic',
  },

  HR_ENGAGEMENT_MAIN: {
    name: 'HR Engagement Main',
    nameRu: 'Вовлеченность',
    link: '/engagement',
    icon: 'megaphone',
    type: 'basic',
  },

  HR_ENGAGEMENT_NEWS: {
    name: 'HR Engagement News',
    nameRu: 'Новости',
    link: '/engagement/news',
    icon: 'newspaper',
    type: 'basic',
  },

  HR_ENGAGEMENT_SURVEYS: {
    name: 'HR Engagement Surveys',
    nameRu: 'Опросы',
    link: '/engagement/surveys',
    icon: 'clipboardlist',
    type: 'basic',
  },

  HR_PERFORMANCE_ACHIEVEMENTS: {
    name: 'HR Performance Achievements',
    nameRu: 'Достижения',
    link: '/performance/achievements',
    icon: 'award',
    type: 'basic',
  },

  HR_PERFORMANCE_GROUP: {
    name: 'HR Performance Group',
    nameRu: 'Производительность',
    type: 'group',
  },

  HR_PERFORMANCE_KPI: {
    name: 'HR Performance KPI',
    nameRu: 'KPI',
    link: '/performance/kpi',
    icon: 'target',
    type: 'basic',
  },

  HR_PERFORMANCE_MAIN: {
    name: 'HR Performance Main',
    nameRu: 'Производительность',
    link: '/performance',
    icon: 'gauge',
    type: 'basic',
  },

  HR_TIMESHEET_GROUP: {
    name: 'HR Timesheet Group',
    nameRu: 'Рабочее время',
    type: 'group',
  },

  HR_TIMESHEET_MAIN: {
    name: 'HR Timesheet Main',
    nameRu: 'Табель',
    link: '/timesheet',
    icon: 'clock',
    type: 'basic',
  },

  HR_TIMESHEET_VACATIONS: {
    name: 'HR Timesheet Vacations',
    nameRu: 'Отпуска',
    link: '/hr/vacations',
    icon: 'plane',
    type: 'basic',
  },

  LINKS_ANALYTICS: {
    name: 'Links Analytics',
    nameRu: 'Аналитика',
    link: '/links/analytics',
    icon: 'barchart',
    type: 'basic',
  },

  LINKS_CONVERSIONS: {
    name: 'Links Conversions',
    nameRu: 'Конверсии',
    link: '/links/conversions',
    icon: 'trendingup',
    type: 'basic',
  },

  LINKS_DASHBOARD: {
    name: 'Links Dashboard',
    nameRu: 'Панель',
    link: '/links',
    icon: 'layoutdashboard',
    type: 'basic',
  },

  LINKS_GROUP: {
    name: 'Links Group',
    nameRu: 'Ссылки',
    type: 'group',
  },

  LINKS_LIST: {
    name: 'Links List',
    nameRu: 'Все ссылки',
    link: '/links/list',
    icon: 'listordered',
    type: 'basic',
  },

  LINKS_QR: {
    name: 'Links QR',
    nameRu: 'QR-коды',
    link: '/links/qr',
    icon: 'grid',
    type: 'basic',
  },

  LINKS_SLUGS: {
    name: 'Links Slugs',
    nameRu: 'Слаги',
    link: '/links/slugs',
    icon: 'globe',
    type: 'basic',
  },

  LINKS_TEMPLATES: {
    name: 'Links Templates',
    nameRu: 'Шаблоны',
    link: '/links/templates',
    icon: 'filetext',
    type: 'basic',
  },

  MOBILE_ROOT: {
    name: 'Mobile Root',
    nameRu: 'Мобильный',
    type: 'group',
  },

  SETTINGS_BALANCE: {
    name: 'Settings Balance',
    nameRu: 'Баланс',
    type: 'basic',
  },

  SETTINGS_BILLING: {
    name: 'Settings Billing',
    nameRu: 'Биллинг',
    type: 'basic',
  },

  SETTINGS_SAVED_MESSAGES: {
    name: 'Settings Saved Messages',
    nameRu: 'Сохранённые сообщения',
    type: 'basic',
  },

  SETTINGS_VERIFICATION: {
    name: 'Settings Verification',
    nameRu: 'Верификация',
    type: 'basic',
  },

  SETTINGS_WALLET: {
    name: 'Settings Wallet',
    nameRu: 'Кошелёк',
    type: 'basic',
  },

  STORAGE_ACTIVITY: {
    name: 'Storage Activity',
    nameRu: 'Активность',
    link: '/storage/activity',
    icon: 'activity',
    type: 'basic',
  },

  STORAGE_ANALYTICS: {
    name: 'Storage Analytics',
    nameRu: 'Аналитика',
    type: 'basic',
  },

  STORAGE_DETAILS: {
    name: 'Storage Details',
    nameRu: 'Подробности',
    type: 'group',
  },

  STORAGE_FILES: {
    name: 'Storage Files',
    nameRu: 'Файлы',
    link: '/storage',
    icon: 'folderopen',
    type: 'basic',
  },

  STORAGE_FILE_LOG: {
    name: 'Storage File Log',
    nameRu: 'Журнал файлов',
    type: 'basic',
  },

  STORAGE_GROUP: {
    name: 'Storage Group',
    nameRu: 'Хранилище',
    link: '/storage',
    icon: 'harddrive',
    type: 'group',
  },

  STORAGE_INCOMING: {
    name: 'Storage Incoming',
    nameRu: 'Входящие',
    link: '/storage/shared/incoming',
    icon: 'phoneincoming',
    type: 'basic',
  },

  STORAGE_MAIN: {
    name: 'Storage Main',
    nameRu: 'Хранилище',
    link: '/storage',
    icon: 'harddrive',
    type: 'basic',
  },

  STORAGE_MENU: {
    name: 'Storage Menu',
    nameRu: 'Хранилище (Админ)',
    type: 'group',
  },

  STORAGE_OUTGOING: {
    name: 'Storage Outgoing',
    nameRu: 'Исходящие',
    link: '/storage/shared/outgoing',
    icon: 'phoneoutgoing',
    type: 'basic',
  },

  STORAGE_PERMS: {
    name: 'Storage Perms',
    nameRu: 'Разрешения',
    link: '/storage/permissions',
    icon: 'lock',
    type: 'basic',
  },

  STORAGE_QUOTA: {
    name: 'Storage Quota',
    nameRu: 'Квота',
    link: '/storage/quota',
    icon: 'gauge',
    type: 'basic',
  },

  STORAGE_RECENT: {
    name: 'Storage Recent',
    nameRu: 'Недавние',
    link: '/storage/recent',
    icon: 'clock',
    type: 'basic',
  },

  STORAGE_SEARCH: {
    name: 'Storage Search',
    nameRu: 'Поиск',
    link: '/storage/search',
    icon: 'usersearch',
    type: 'basic',
  },

  STORAGE_SHARED: {
    name: 'Storage Shared',
    nameRu: 'Общие',
    type: 'group',
  },

  STORAGE_SHARING: {
    name: 'Storage Sharing',
    nameRu: 'Общий доступ',
    type: 'basic',
  },

  STORAGE_STARRED: {
    name: 'Storage Starred',
    nameRu: 'Избранное',
    link: '/storage/starred',
    icon: 'bookmark',
    type: 'basic',
  },

  STORAGE_STATS: {
    name: 'Storage Stats',
    nameRu: 'Статистика',
    type: 'basic',
  },

  STORAGE_TRASH: {
    name: 'Storage Trash',
    nameRu: 'Корзина',
    link: '/storage/trash',
    icon: 'filetext',
    type: 'basic',
  },

  STORAGE_VERSIONS: {
    name: 'Storage Versions',
    nameRu: 'Версии',
    type: 'basic',
  },

  USERS_DASHBOARD: {
    name: 'Users Dashboard',
    nameRu: 'Панель',
    link: '/admin/users',
    icon: 'layoutdashboard',
    type: 'basic',
  },

  USER_ACTIVITY: {
    name: 'User Activity',
    nameRu: 'Активность',
    type: 'basic',
  },

  USER_APPS: {
    name: 'User Apps',
    nameRu: 'Приложения',
    type: 'basic',
  },

  USER_BILLING: {
    name: 'User Billing',
    nameRu: 'Биллинг',
    type: 'basic',
  },

  USER_BLOCKED: {
    name: 'User Blocked',
    nameRu: 'Заблокированные',
    type: 'basic',
  },

  USER_CALLS: {
    name: 'User Calls',
    nameRu: 'История звонков',
    type: 'basic',
  },

  USER_CALL_SETTINGS: {
    name: 'User Call Settings',
    nameRu: 'Настройки звонков',
    type: 'basic',
  },

  USER_DOCUMENTS: {
    name: 'User Documents',
    nameRu: 'Документы',
    type: 'basic',
  },

  USER_INFO: {
    name: 'User Info',
    nameRu: 'Информация',
    type: 'group',
  },

  USER_INFO_EDIT: {
    name: 'User Info Edit',
    nameRu: 'Редактирование',
    type: 'basic',
  },

  USER_INTENTS: {
    name: 'User Intents',
    nameRu: 'Платёжные намерения',
    type: 'basic',
  },

  USER_INTERACTIONS: {
    name: 'User Interactions',
    nameRu: 'Взаимодействия',
    type: 'basic',
  },

  USER_MIGRATION: {
    name: 'User Migration',
    nameRu: 'Миграция',
    type: 'basic',
  },

  USER_PRIVACY: {
    name: 'User Privacy',
    nameRu: 'Конфиденциальность',
    type: 'basic',
  },

  USER_PROFILE: {
    name: 'User Profile',
    nameRu: 'Профиль пользователя',
    type: 'group',
  },

  USER_SESSIONS: {
    name: 'User Sessions',
    nameRu: 'Сессии',
    type: 'basic',
  },

  USER_SETTINGS: {
    name: 'User Settings',
    nameRu: 'Настройки',
    type: 'basic',
  },

  USER_SOURCES: {
    name: 'User Sources',
    nameRu: 'Способы оплаты',
    type: 'basic',
  },

  USER_STORAGE: {
    name: 'User Storage',
    nameRu: 'Хранилище',
    type: 'basic',
  },

  USER_TRANSACTIONS: {
    name: 'User Transactions',
    nameRu: 'Транзакции',
    type: 'basic',
  },

  USER_TRANSFERS: {
    name: 'User Transfers',
    nameRu: 'Переводы',
    type: 'basic',
  },

  USER_WALLET: {
    name: 'User Wallet',
    nameRu: 'Кошелёк',
    type: 'group',
  },
}

// NOTE: Navigation state is now in navigationMachine (XState). Use hooks from @/stores.
